import { render } from "./SalesAssociationServiceParameter.vue?vue&type=template&id=3d830f12&scoped=true"
import script from "./SalesAssociationServiceParameter.vue?vue&type=script&lang=ts"
export * from "./SalesAssociationServiceParameter.vue?vue&type=script&lang=ts"

import "./SalesAssociationServiceParameter.vue?vue&type=style&index=0&id=3d830f12&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3d830f12"

export default script